import fbConfig from '../../config/fbConfig'

// Registro de un usuario
export const signUp = ({name, surname, email, password}) => {
    return async (dispatch, getState) => {

        // Guardamos el nuevo usuario en la BBDD
        const user = await fbConfig.auth().createUserWithEmailAndPassword(email, password);
        // Obtenemos las preferencias de privacidad y las guardamos para el usuario
        const prefsPrivacity = await fbConfig.firestore().collection('preferences_privacity').get();

        let preferences_privacity = prefsPrivacity.docs.map(prefP => {
            return {
                id: prefP.id,
                active: false
            }
        })
        
        await fbConfig.firestore().collection('users').doc(user.user.uid).set({
            id: user.user.uid,
            name,
            surname,
            email,
            preferences_privacity,
            image_profile: null, // cambiar por una imagen por defecto
            shield_points: [],
            mode: 'rewards',
            cookies: 0,
            created_at: fbConfig.firestore.FieldValue.serverTimestamp(),
            updated_at: fbConfig.firestore.FieldValue.serverTimestamp()
        });

        await dispatch({ type: 'CREATE_USER_SUCCESS', uid: user.user.uid });


    }
}

// Funcion para registrarse con redes sociales
export const signUpWithSocialMedia = idSocialMedia => {
    return async (dispatch, getState) => {

        // Obtenemos el proveedor
        let provider;
        switch (idSocialMedia) {
            case 'google':
                provider = new fbConfig.auth.GoogleAuthProvider();
                break;
            case 'facebook':
                provider = new fbConfig.auth.FacebookAuthProvider();
                break;
            case 'twitter':
                provider = new fbConfig.auth.TwitterAuthProvider();
                break;
            default:
                break;
        }

        if(provider) {

            // Comprobamos si nuestra sesion esta activa
            const user = await fbConfig.auth().currentUser;
            
            if(user && user.uid) {
                await fbConfig.auth().signOut();
            }

            const response = await fbConfig.auth().signInWithPopup(provider)
            
            if(response && response.user) {
                const { providerData } = response.user;

                const { uid } = await fbConfig.auth().currentUser

                const { displayName, email, photoURL } = providerData[0];

                // Obtenemos las preferencias de privacidad y las guardamos para el usuario
                const prefsPrivacity = await fbConfig.firestore().collection('preferences_privacity').get();

                let preferences_privacity = prefsPrivacity.docs.map(prefP => {
                    return {
                        id: prefP.id,
                        active: false
                    }
                })

                // Guardamos los datos en la BBDD
                await fbConfig.firestore().collection('users').doc(uid).set({
                    id: uid,
                    name: displayName,
                    surname: null,
                    email: email || null,
                    image_profile: photoURL,
                    preferences_privacity,
                    shield_points: [],
                    mode: 'rewards',
                    cookies: 0,
                    created_at: fbConfig.firestore.FieldValue.serverTimestamp(),
                    updated_at: fbConfig.firestore.FieldValue.serverTimestamp()
                })

                await dispatch({ type: 'CREATE_USER_SUCCESS', uid });

            }
 
        }
    }
}

// Funcion para iniciar sesion manualmente
export const signIn = credentials => {
    return async (dispatch, getState) => {

        // Comprobamos si nuestra sesion esta activa
        const user = await fbConfig.auth().currentUser;
            
        if(user && user.uid) {
            await fbConfig.auth().signOut();
        }

        const { email, password } = credentials;

        fbConfig.auth().signInWithEmailAndPassword(email, password).then( user => {

            dispatch({ type: 'SIGNIN_SUCCESS', uid: user.user.uid })

        }).catch(err => {

            dispatch({ type: 'SIGNIN_FAILED', err })

        })

    }
}

// Funcion para setear a null el uid
export const setNullUid = () => {
    return (dispatch, getState) => {
        dispatch({ type: 'SIGNIN_SUCCESS', uid: null })
    }
}

// Funcion para iniciar sesion con redes sociales
export const signInWithSocialMedia = idSocialMedia => {
    return async (dispatch, getState) => {

        let provider;
        switch (idSocialMedia) {
            case 'google':
                provider = new fbConfig.auth.GoogleAuthProvider();
                break;
            case 'facebook':
                provider = new fbConfig.auth.FacebookAuthProvider();
                break;
            case 'twitter':
                provider = new fbConfig.auth.TwitterAuthProvider();
                break;
            default:
                break;
        }

        if(provider) {

            // Comprobamos si nuestra sesion esta activa
            const user = await fbConfig.auth().currentUser;

            if(user && user.uid) {
                await fbConfig.auth().signOut();
            }

            fbConfig.auth().signInWithPopup(provider).then(response => {

                const { providerData } = response.user;
                const { displayName, email, photoURL } = providerData[0];
                
                const { uid } = fbConfig.auth().currentUser

                // Comprobamos si ese usuario esta registrado
                fbConfig.firestore().collection('users').doc(uid).get().then(async user => {

                    if(user.exists) {

                        dispatch({ type: 'SIGNIN_SUCCESS', uid })

                    }else {

                        // Obtenemos las preferencias de privacidad y las guardamos para el usuario
                        const prefsPrivacity = await fbConfig.firestore().collection('preferences_privacity').get();

                        let preferences_privacity = prefsPrivacity.docs.map(prefP => {
                            return {
                                id: prefP.id,
                                active: false
                            }
                        })

                        await fbConfig.firestore().collection('users').doc(uid).set({
                            id: uid,
                            name: displayName,
                            surname: null,
                            email: email || null,
                            image_profile: photoURL,
                            preferences_privacity,
                            shield_points: [],
                            mode: 'rewards',
                            cookies: 0,
                            created_at: fbConfig.firestore.FieldValue.serverTimestamp(),
                            updated_at: fbConfig.firestore.FieldValue.serverTimestamp()
                        })

                    }

                }).catch(err => {
                    console.log(err)
                })

            }).catch(err => {
                
                if(err.code === 'auth/account-exists-with-different-credential') {
                    dispatch({ type: 'SIGNIN_FAILED', err })
                }

            })
 
        }

    }
}

// Funcion para recuperar la constraseña
export const recoverPassword = async ({email}) => {

    try {
        
        await fbConfig.auth().sendPasswordResetEmail(email);

        return {
            status: true
        }

    } catch (error) {
        console.error(error)
        return {error}
    }

}

// Funcion para cerrar sesion 
export const signOut = () => {
    return async (dispatch, getState) => {

        await fbConfig.auth().signOut()

    }
}